export const postMessageToMainOnBroadcastChannel = (channel, message) => {
    channel.postMessage(message);
};
export const postMessageToSwOnBroadcastChannel = (channel, message) => {
    channel.postMessage(message);
};
